import { entryFor, isNativeShell, readVisitorHint } from './features/landing/entry';
import { restaurantRoute } from './features/restaurant/entry';

/**
 * Sengaja hanya memilih titik masuk. Semua fitur didaftarkan lewat feature.tsx yang memuat @sassly/ui dan kit
 * penuh (lebih dari 1 MB), padahal halaman tamu /q/:token harus tampil di bawah 2 detik di 4G pada HP murah.
 */
const path = window.location.pathname;

if (path.startsWith('/q/')) {
  void import('./features/qr/boot');
} else if (/^\/wl?\//.test(path)) {
  // Halaman tamu antrian masuk dari QR pintu, sama ringannya dengan halaman QR order.
  void import('./features/waitlist/guest/boot');
} else if (restaurantRoute(path) && !isNativeShell()) {
  // Halaman resto untuk tamu (kobe.sassly.ai/{slug}): sama ringannya dengan halaman QR.
  void import('./features/restaurant/boot');
} else if (entryFor(path, { hint: readVisitorHint(), native: isNativeShell() }) === 'site') {
  // Halaman depan, syarat, dan privasi untuk calon pelanggan: tanpa kit berat. Member di / tetap ke Beranda.
  void import('./features/landing/boot');
} else {
  void import('./appBoot');
}

export {};
